module.exports = __webpack_public_path__ + "officialStatic/img/case46.c44bdf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case46.jpg
// module id = HDeh
// module chunks = 0